/** Product name from the build (VITE_BRAND_NAME ← BRAND_NAME in docker-compose.yml). */
export const BRAND_NAME: string = import.meta.env.VITE_BRAND_NAME?.trim() || 'Faceless Bot';

/** Bot username without '@' (VITE_BOT_USERNAME ← BOT_USERNAME); empty when the build has none. */
export const BOT_USERNAME: string = (import.meta.env.VITE_BOT_USERNAME ?? '').trim().replace(/^@/, '');
